import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initBugsnag } from "./lib/bugsnag";

// Initialize Bugsnag error tracking
initBugsnag();

createRoot(document.getElementById("root")!).render(<App />);
